// extracted by mini-css-extract-plugin
module.exports = {"cost-saving":"OffGrid_cost-saving__Z2kpl"};